var LOCALE = (function ($, window, document, undefined) {
  var GEO_IP_ENDPOINT = 'https://ipapi.co/json/';
  var PACKAGE_STORAGE_KEY = 'b48:selectedPackage';
  var DEFAULT_CURRENCY = 'gbp';
  var DEFAULT_COUNTRY = 'United Kingdom';
  var DEFAULT_COUNTRY_CODE = 'GB';
  var HERO_REVEAL_TIMEOUT_MS = 3000;
  var heroRevealTimer = null;
  var heroRevealDone = false;
  var testGeoLocally = false;// use http://localhost:3000 to test geo ip locally
  var geoIpResult = null;
  var usCopyApplied = false;

  // Must update these prices when setting prices in Stripe.
  var PRICE_TABLE = {
    gbp: {
      code: 'GBP',
      symbol: '£',
      phoneCode: '+44',
      packages: {
        Basic: 290,
        Standard: 450,
        MAX: 860,
        AddOnStandard: 200,
        AddOnMAX: 450
      }
    },
    usd: {
      code: 'USD',
      symbol: '$',
      phoneCode: '+1',
      packages: {
        Basic: 400,
        Standard: 600,
        MAX: 1160,
        AddOnStandard: 275,
        AddOnMAX: 600
      }
    },
    eur: {
      code: 'EUR',
      symbol: '€',
      phoneCode: null,
      packages: {
        Basic: 350,
        Standard: 520,
        MAX: 990,
        AddOnStandard: 230,
        AddOnMAX: 520
      }
    },
    aed: {
      code: 'AED',
      symbol: 'د.إ',
      phoneCode: '+971',
      packages: {
        Basic: 1450,
        Standard: 2200,
        MAX: 4250,
        AddOnStandard: 1000,
        AddOnMAX: 2200
      }
    },
    aud: {
      code: 'AUD',
      symbol: 'A$',
      phoneCode: '+61',
      packages: {
        Basic: 570,
        Standard: 900,
        MAX: 1750,
        AddOnStandard: 390,
        AddOnMAX: 900
      }
    },
    cad: {
      code: 'CAD',
      symbol: 'C$',
      phoneCode: '+1',
      packages: {
        Basic: 540,
        Standard: 830,
        MAX: 1590,
        AddOnStandard: 380,
        AddOnMAX: 830
      }
    }
  };

  var DEFAULT_PHONE_CODE = (PRICE_TABLE[DEFAULT_CURRENCY] && PRICE_TABLE[DEFAULT_CURRENCY].phoneCode) || '+44';

  var TAX_NOTES = {
    gbp: 'inc. VAT',
    usd: 'inc. sales tax',
    eur: '',
    aed: '',
    aud: '',
    cad: ''
  };

  var localeState = {
    countryName: DEFAULT_COUNTRY,
    countryCode: DEFAULT_COUNTRY_CODE,
    currency: DEFAULT_CURRENCY,
    detected: false
  };

  function ensureGeoIpPromise() {
    if (window._b48GeoIpPromise) {
      return window._b48GeoIpPromise;
    }
    var isLocal = MAIN.isLocalEnv();
    // Check if we're on the Live environment or testing Geo-IP locally.
    if (isLocal && !testGeoLocally) {
      // Don't bother with Geo-IP for local development.
      geoIpResult = null;
      window._b48GeoIpPromise = Promise.resolve(null);
      return window._b48GeoIpPromise;
    }
    window._b48GeoIpPromise = fetch(GEO_IP_ENDPOINT, { method: 'GET' })
      .then(function (res) {
        if (!res || !res.ok) {
          throw new Error('geo ip failed');
        }
        return res.json();
      })
      .then(function (geo) {
        geoIpResult = geo || null;
        return geoIpResult;
      })
      .catch(function () {
        geoIpResult = null;
        return null;
      });
    return window._b48GeoIpPromise;
  }

  function loadStoredPackage() {
    try {
      var raw = localStorage.getItem(PACKAGE_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveStoredPackage(pkg) {
    if (!pkg) { return; }
    try {
      localStorage.setItem(PACKAGE_STORAGE_KEY, JSON.stringify(pkg));
    } catch (e) { }
  }

  function determineCurrency(geo) {
    var countryCode = geo && geo.country_code ? String(geo.country_code).toUpperCase() : '';
    var countryName = geo && (geo.country_name || geo.country) ? String(geo.country_name || geo.country) : '';
    var countryLower = countryName.toLowerCase();

    if (countryCode === 'AE' || countryLower.indexOf('united arab emirates') !== -1) {
      return 'aed';
    }
    if (countryCode === 'US' || countryLower.indexOf('united states') !== -1) {
      return 'usd';
    }
    if (countryCode === 'GB' || countryCode === 'UK' || countryLower.indexOf('united kingdom') !== -1 || countryLower.indexOf('great britain') !== -1) {
      return 'gbp';
    }
    if (countryCode === 'AU' || countryLower.indexOf('australia') !== -1) {
      return 'aud';
    }
    if (countryCode === 'CA' || countryLower.indexOf('canada') !== -1) {
      return 'cad';
    }
    var eurCountries = [
      'AT','BE','CY','EE','FI','FR','DE','GR','IE','IT','LV','LT','LU','MT','NL','PT','SK','SI','ES','HR','BG',
      'MC','VA','SM','AD','ME','XK'// Non-EU-Eurozone countries that use Euro
    ];
    if (eurCountries.indexOf(countryCode) !== -1 || countryLower.indexOf('euro') !== -1) {
      return 'eur';
    }
    return DEFAULT_CURRENCY;
  }

  function formatPrice(currency, amount) {
    var cfg = PRICE_TABLE[currency] || PRICE_TABLE[DEFAULT_CURRENCY];
    try {
      var locale = 'en-GB';
      if (currency === 'usd') locale = 'en-US';
      else if (currency === 'eur') locale = 'de-DE';
      else if (currency === 'aed') locale = 'ar-AE';
      else if (currency === 'aud') locale = 'en-AU';
      else if (currency === 'cad') locale = 'en-CA';
      var formattedNumber = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
      return (cfg.symbol || '') + formattedNumber;
    } catch (e) {
      return (cfg.symbol || '') + amount;
    }
  }

  function formatRange(currency) {
    var base = { low: 2000, high: 5000 }; // GBP-authored comparison range
    var gbpCfg = PRICE_TABLE.gbp;
    var targetCfg = PRICE_TABLE[currency] || gbpCfg;
    var gbpBase = (gbpCfg && gbpCfg.packages && gbpCfg.packages.Basic) ? gbpCfg.packages.Basic : 1;
    var tgtBase = (targetCfg && targetCfg.packages && targetCfg.packages.Basic) ? targetCfg.packages.Basic : gbpBase;
    var ratio = gbpBase ? (tgtBase / gbpBase) : 1;
    var low = Math.max(500, Math.round(base.low * ratio / 500) * 500);
    var high = Math.max(low + 500, Math.round(base.high * ratio / 500) * 500);
    return formatPrice(currency, low) + ' - ' + formatPrice(currency, high) + '+';
  }

  // Add 20% to a price and round to a friendly number ending in 0 or 5.
  function calculateWasPrice(baseAmount) {
    var raw = (Number(baseAmount) || 0) * 1.2;
    // Round to nearest 5 (i.e., numbers ending with 0 or 5).
    var remainder = raw % 5;
    if (remainder === 0) {
      return Math.round(raw);
    }
    return Math.round(raw - remainder + (remainder < 2.5 ? 0 : 5));
  }

  function getFormattedWasPrices(currency) {
    // Keep GBP "was" prices as authored in the markup.
    if (currency === 'gbp') {
      return null;
    }
    var cfg = PRICE_TABLE[currency] || PRICE_TABLE[DEFAULT_CURRENCY];
    var result = {};
    for (var name in cfg.packages) {
      if (!cfg.packages.hasOwnProperty(name)) { continue; }
      var wasValue = calculateWasPrice(cfg.packages[name]);
      result[name] = formatPrice(currency, wasValue);
    }
    return result;
  }

  function getTaxNote(currency) {
    var note = TAX_NOTES[currency];
    return typeof note === 'string' ? note : '';
  }

  // Apply US-specific spelling corrections if the currency is USD or the country is US.
  function applyUsTerms(currency, countryCode) {
    var isUsCurrency = currency && String(currency).toLowerCase() === 'usd';
    var isUsCountry = countryCode && String(countryCode).toUpperCase() === 'US';
    if (!isUsCurrency && !isUsCountry) {
      return;
    }
    if (usCopyApplied || typeof $ === 'undefined') {
      return;
    }

    var replacements = [
      // Phrases first to avoid partial overlaps
      { re: /\bbespoke\b/gi, to: 'custom' },
      // UK → US spellings
      { re: /\bcolour\b/gi, to: 'color' },
      { re: /\bbehaviour\b/gi, to: 'behavior' },
      { re: /\borganise\b/gi, to: 'organize' },
      { re: /\borganisation\b/gi, to: 'organization' },
      { re: /\brealise\b/gi, to: 'realize' },
      { re: /\bmaximise\b/gi, to: 'maximize' },
      { re: /\bspecialise\b/gi, to: 'specialize' },
      { re: /\bvisualisation\b/gi, to: 'visualization' },
      { re: /\boptimisation\b/gi, to: 'optimization' },
      { re: /\bgrey\b/gi, to: 'gray' }
    ];

    var $textNodes = $('body')
      .find('*')
      .contents()
      .filter(function () {
        if (this.nodeType !== 3) { return false; }
        var parent = this.parentNode;
        if (!parent || !parent.nodeName) { return false; }
        // Skip scripts/styles/code-like blocks and form controls
        if ($(parent).closest('script, style, noscript, code, pre, svg').length) { return false; }
        if ($(parent).closest('input, textarea, select, option').length) { return false; }
        return this.nodeValue && this.nodeValue.trim().length;
      });

    $textNodes.each(function () {
      var text = this.nodeValue;
      for (var i = 0; i < replacements.length; i++) {
        text = text.replace(replacements[i].re, replacements[i].to);
      }
      this.nodeValue = text;
    });
    usCopyApplied = true;
  }

  function getPhonePrefix(currency) {
    var cfg = PRICE_TABLE[currency];
    var prefix = cfg && cfg.phoneCode;
    if (prefix) { return prefix; }
    var fallback = PRICE_TABLE[DEFAULT_CURRENCY];
    return (fallback && fallback.phoneCode) ? fallback.phoneCode : DEFAULT_PHONE_CODE;
  }

  function updatePhonePrefixes(currency) {
    var newPrefix = getPhonePrefix(currency) || DEFAULT_PHONE_CODE;
    $('.country-code input[type="tel"]').val(newPrefix);
  }

  function getFormattedPrices(currency) {
    var cfg = PRICE_TABLE[currency] || PRICE_TABLE[DEFAULT_CURRENCY];
    var result = {};
    for (var name in cfg.packages) {
      if (!cfg.packages.hasOwnProperty(name)) { continue; }
      result[name] = formatPrice(currency, cfg.packages[name]);
    }
    return result;
  }

  function getSummaryForPackage(name) {
    var $btn = $('.order-trigger[data-package-name="' + name + '"]').first();
    return $btn.length ? ($btn.attr('data-package-summary') || '') : '';
  }

  function revealHeroHighlight() {
    if (heroRevealDone) { return; }
    heroRevealDone = true;
    if (heroRevealTimer) {
      clearTimeout(heroRevealTimer);
      heroRevealTimer = null;
    }
    $('.js-from-highlight').addClass('is-visible');
  }

  function scheduleHeroRevealFallback() {
    if (heroRevealDone || heroRevealTimer) { return; }
    heroRevealTimer = setTimeout(function () {
      heroRevealTimer = null;
      revealHeroHighlight();
    }, HERO_REVEAL_TIMEOUT_MS);
  }

  function updatePackageCards(prices, wasPrices, taxNote) {
    Object.keys(prices).forEach(function (name) {
      var formattedPrice = prices[name];
      var $cards = $('.package').filter(function () {
        var heading = $(this).find('.package-header h2').first().text().trim().toLowerCase();
        return heading === String(name).toLowerCase();
      });

      // Upgrades have headings like "Upgrade to Standard", so they won't match `name`.
      // For keys like "AddOnStandard" / "AddOnMAX", match the card via the order button.
      if (!$cards.length && /^AddOn/i.test(name)) {
        var addOnLabel = String(name).replace(/^AddOn/i, '');
        var packageName = addOnLabel + ' Upgrade';
        var $btn = $('.order-trigger[data-package-name="' + packageName + '"]').first();
        if ($btn.length) {
          $cards = $cards.add($btn.closest('.package'));
        }
      }
      $cards.each(function () {
        var $card = $(this);
        var $price = $card.find('.js-price').first();
        if ($price.length) {
          $price.text(formattedPrice);
        }
        var $was = $card.find('.was').first();
        if ($was.length && wasPrices && wasPrices[name]) {
          $was.text(wasPrices[name]);
        }
        var $tax = $card.find('.js-tax-note').first();
        if ($tax.length) {
          if (taxNote) {
            $tax.text(taxNote).show();
          } else {
            $tax.text('').hide();
          }
        }
        var $btns = $card.find('.order-trigger');
        if ($btns.length) {
          $btns.attr('data-package-price', formattedPrice);
          if (taxNote) {
            $btns.attr('data-package-tax-note', taxNote);
          } else {
            $btns.removeAttr('data-package-tax-note');
          }
        }
      });
    });
  }

  function updatePackageSummary(pkg, taxNote) {
    if (!pkg) { return; }
    $('.package-summary').each(function () {
      var $wrap = $(this);
      var $title = $wrap.find('.js-package-name');
      if ($title.length && pkg.name) {
        $title.text(pkg.name);
      }
      var $summary = $wrap.find('.js-package-summary');
      if ($summary.length && pkg.summary) {
        $summary.text(pkg.summary);
      }
      var $price = $wrap.find('.js-price').first();
      if ($price.length && pkg.price) {
        $price.text(pkg.price);
      }
      var $tax = $wrap.find('.js-tax-note').first();
      if ($tax.length) {
        if (taxNote) {
          $tax.text(taxNote).show();
        } else {
          $tax.text('').hide();
        }
      }
    });
  }

  function updateOtherPriceSpots(lowestPrice) {
    var $heroPrice = $('.js-price-hero').first();
    if ($heroPrice.length) {
      $heroPrice.text(lowestPrice);
    }
    var $matrixPrice = $('.js-price-matrix').first();
    if ($matrixPrice.length) {
      $matrixPrice.text(lowestPrice);
    }
    var $matrixPriceRange = $('.js-price-matrix-range').first();
    if ($matrixPriceRange.length) {
      var range = formatRange(localeState.currency);
      $matrixPriceRange.text(range);
    }
  }

  function syncStoredPackage(prices, taxNote) {
    var stored = loadStoredPackage();
    var packageName = (stored && prices[stored.name]) ? stored.name : 'Standard';
    var pkg = {
      name: packageName,
      summary: (stored && stored.summary) ? stored.summary : getSummaryForPackage(packageName),
      price: prices[packageName],
      taxNote: taxNote
    };
    saveStoredPackage(pkg);
    updatePackageSummary(pkg, taxNote);
  }

  function setCountryField(countryName, countryCode) {
    var $select = $('#order-country');
    if (!$select.length) { return; }
    var candidates = [];
    if (countryName) { candidates.push(countryName); }
    if (countryCode === 'US') { candidates.push('United States of America', 'United States'); }
    if (countryCode === 'GB' || countryCode === 'UK') { candidates.push('United Kingdom'); }
    if (!candidates.length && localeState.currency === 'usd') {
      candidates.push('United States of America');
    }
    if (!candidates.length) {
      candidates.push(DEFAULT_COUNTRY);
    }

    var options = $select.find('option');
    for (var i = 0; i < candidates.length; i++) {
      var target = String(candidates[i]).toLowerCase();
      var $match = options.filter(function () {
        return String($(this).val()).toLowerCase() === target;
      }).first();
      if ($match.length) {
        options.prop('selected', false);
        $match.prop('selected', true);
        $select.trigger('change');
        return;
      }
    }
  }

  function applyLocale(countryName, countryCode, currency) {
    var targetCurrency = PRICE_TABLE[currency] ? currency : DEFAULT_CURRENCY;
    var prices = getFormattedPrices(targetCurrency);
    var wasPrices = getFormattedWasPrices(targetCurrency);
    var taxNote = getTaxNote(targetCurrency);
    localeState.currency = targetCurrency;
    localeState.countryName = countryName || localeState.countryName || DEFAULT_COUNTRY;
    localeState.countryCode = countryCode || localeState.countryCode || DEFAULT_COUNTRY_CODE;

    updatePackageCards(prices, wasPrices, taxNote);
    syncStoredPackage(prices, taxNote);
    updateOtherPriceSpots(prices.Basic);
    setCountryField(countryName, countryCode);
    updatePhonePrefixes(targetCurrency);
    applyUsTerms(targetCurrency, localeState.countryCode);
  }

  function detectAndApplyLocale() {
    return ensureGeoIpPromise()
      .then(function (geo) {
        if (!geo) {
          applyLocale(DEFAULT_COUNTRY, DEFAULT_COUNTRY_CODE, DEFAULT_CURRENCY);
          revealHeroHighlight();
          return;
        }
        var currency = determineCurrency(geo);
        localeState.detected = true;
        localeState.countryName = geo.country_name || geo.country || localeState.countryName;
        localeState.countryCode = geo.country_code || localeState.countryCode;
        applyLocale(localeState.countryName, localeState.countryCode, currency);
        revealHeroHighlight();
      })
      .catch(function () {
        applyLocale(DEFAULT_COUNTRY, DEFAULT_COUNTRY_CODE, DEFAULT_CURRENCY);
        revealHeroHighlight();
      });
  }

  $(function () {
    scheduleHeroRevealFallback();
    applyLocale(localeState.countryName, localeState.countryCode, localeState.currency);
    detectAndApplyLocale();
  });

  return {
    getCurrency: function () { return localeState.currency || DEFAULT_CURRENCY; },
    getCountry: function () { return localeState.countryName || DEFAULT_COUNTRY; },
    getGeoIpResult: function () { return geoIpResult; },
    getLocale: function () {
      return {
        countryName: localeState.countryName,
        countryCode: localeState.countryCode,
        currency: localeState.currency,
        detected: localeState.detected
      };
    }
  };
})(jQuery, window, document);

